import Indicator from "./Indicator";
import useTopCategories from "../../hooks/useTopCategories";
import {ITopCategory} from "../../interfaces/ITopCategory";
import styled from "styled-components";
// @ts-ignore
import Link from "next/link";
import Col from "react-bootstrap/Col";
import ImageWithFallback from "../ImageWithFallback";
import {getNavPath} from "../../shared/navigateUtil";
import {useRouter} from "next/router";
import React, {useEffect, useState} from "react";
import {useMessages} from "../../hooks/useMessages";
import useCustomCategories from "../../hooks/useCustomCategories";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import {useCountryLang} from "../../hooks/useCountryLang";
import Icon from "../Icon";
import MenuSubcategory from "../category/MenuSubcategory";
import Button from "../Button";
import {getTheme} from "../../shared/themeUtils";
import {useHeaderLinks} from "../../hooks/useHeaderLinks";

const Contain = styled.div`
  ul {
    padding: 0;

    li {
      font-weight: bold;
    }
  }

  .custom-categories {
    margin-bottom: ${getTheme("space.1")};

    .name {
      font-weight: bold;
    }

    li {

    }
  }
`

const Header = styled.div`
  margin-top: ${getTheme("space.1")};
  color: ${getTheme("colors.primary")};
  font-weight: 500;
  display: flex;
  align-items: center;

  span {
    margin-left: 10px;
  }
`

const Element = styled.li`
  list-style: none;
  border-bottom: 1px solid ${getTheme("colors.border")};
  margin-right: ${getTheme("space.2")};
  padding: ${getTheme("space.2")} ${getTheme("space.1")};
  font-size: ${getTheme("fontSizes.medium")};
  display: flex;
  font-weight: 500;
  cursor: pointer;

  .image-contain {
    margin-right: ${getTheme("space.1")};
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 60px;
    height: 60px;
  }

  .text-contain {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    margin-left: ${getTheme("space.1")};
  }
    
    .navigate-subcat-btn {
        padding: 0;
        margin-left: ${getTheme("space.0")};
        height: auto;   
        .direction-icon {
            background-color: ${getTheme("colors.background")};
            padding: ${getTheme("space.0")};
        }
    }
`

const MenuItems = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  width: 100%;

  li {
    text-decoration: none;
    font-weight: bold;
    font-size: ${getTheme("fontSizes.medium")};
    margin: ${getTheme("space.2")} 0;
    cursor: pointer;

    &:hover {
      color: ${getTheme("colors.link")};
    }
  }
`

const IndicatorMenu = () => {
  const topCategoriesQuery = useTopCategories()
  const customCategoriesQuery = useCustomCategories()
  const messagesQuery = useMessages()
  const headerLinksQuery = useHeaderLinks()
  const router = useRouter()
  const countryLang = useCountryLang()

  // Initialize state with server data if available
  const [selectedCategory, setSelectedCategory] = useState<ITopCategory | null>(null)
  const [indicatorTitle, setIndicatorTitle] = useState(() => {
    if (messagesQuery.data) {
      return messagesQuery.data.messages["categories"]
    }
    return ""
  })
  const [activeTab, setActiveTab] = useState("categories")

  // Update indicator title when messages are loaded
  useEffect(() => {
    if (messagesQuery.data) {
      setIndicatorTitle(messagesQuery.data.messages["categories"])
    }
  }, [messagesQuery.data])

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      handleSubCatsClose()
    }
  }, [])

  const navigateToCategory = async (category: ITopCategory) => {
    if (category.customSlug) {
      await router.push(`/${countryLang}/custom/${category.customSlug}`)
    } else {
      await router.push(`/${countryLang}/cat/${category.slug}`)
    }
  }

  const handleSubCatsShow = async (category: ITopCategory) => {
    if (!category.customSlug) {
      setSelectedCategory(category)
    }
  }

  const handleSubCatsClose = () => {
    setSelectedCategory(null)
  }

  const content = (
    <Contain>
      <Tabs
        id="register-type"
        activeKey={activeTab}
        onSelect={k => k != null ? setActiveTab(k) : null}
        unmountOnExit={true}
        className="flat-tabs-big mt-3">

        {messagesQuery.data &&
          <Tab eventKey="categories" title={messagesQuery.data.messages["categories"]}>

            {customCategoriesQuery.data &&
              <div className="custom-categories">
                {customCategoriesQuery.data.map((category: ITopCategory) => {
                  return (
                    <Link
                      href={getNavPath(router, `custom/${category.customSlug}`)}
                      key={category.name}>
                      <Element>
                        <Col xs="2" className="image-contain">
                          {category.imageURL &&
                            <ImageWithFallback key={category.id}
                                               alt={category.name}
                                               src={category.imageURL}
                                               fallbackSrc={'/client-images/box-flat.png'}
                                               layout="fill"
                                               objectFit={"contain"}/>}
                        </Col>
                        <Col className="text-contain">
                          <span className="name">{category.name}</span>
                        </Col>
                      </Element>
                    </Link>
                  );
                })}
              </div>
            }

            <ul>
              {topCategoriesQuery.data && topCategoriesQuery.data.categories?.map((category: ITopCategory) => {
                return (
                  <Element key={category.name}>
                    <Col xs="2"
                         onClick={() => navigateToCategory(category)}
                         className="image-contain">
                      {category.imageURL &&
                        <ImageWithFallback key={category.id}
                                           alt={category.name}
                                           src={category.imageURL}
                                           fallbackSrc={'/client-images/box-flat.png'}
                                           layout="fill"
                                           objectFit={"contain"}/>}
                    </Col>
                    <Col onClick={() => navigateToCategory(category)}
                         className="text-contain">
                      <span>{category.name}</span>
                    </Col>
                    {!category.customSlug &&
                      <Button onClick={() => handleSubCatsShow(category)}
                              variant={"transparent"}
                              className={"navigate-subcat-btn"}>
                        <Icon className="direction-icon"
                              variant="small">
                          arrow-right-line
                        </Icon>
                      </Button>
                    }
                  </Element>
                );
              })}
            </ul>

            {selectedCategory &&
              <MenuSubcategory category={selectedCategory} />
            }
          </Tab>}

        {messagesQuery.data && headerLinksQuery.data &&
          <Tab eventKey="menu" title={messagesQuery.data.messages["menu"]}>
            <MenuItems>
              {headerLinksQuery.data.rightLinks?.map(link => (
                <li key={link.title}>
                  <Link href={`/${link.href}`}>
                    <span>{link.text}</span>
                  </Link>
                </li>
              ))}
            </MenuItems>
          </Tab>
        }
      </Tabs>
    </Contain>
  )

  return (
    <Indicator content={content} iconVariant={"medium"} icon="menu-line" text={indicatorTitle} placement="start"/>
  )
}

export default IndicatorMenu
